module.exports = __webpack_public_path__ + "static/media/bone3_Bitmap.97a00898.png";